import { 
  ChevronLeft, 
  Help, 
  Info, 
  PriorityHigh, 
  Search,
  AddCircle,
  Brush,
  Edit,
  ContentCopy,
  Cancel as MaterialCancel,
  ShoppingCart,
} from '@styled-icons/material';

import {
  Logout,
  ContentCopy as ContentCopyTwoTone,
  Delete,
  Mail,
  Public,
  History,
  Refresh,
  CheckCircle,
  DoneAll,
  Outbound,
  Merge,
  LocalShipping,
  Report,
  Info as InfoTwoTone,
} from '@styled-icons/material-twotone';

import styled from 'styled-components';
import theme from '@config/theme';

// Existing icons
const ChevronLeftIcon = styled(ChevronLeft)`
  width: 24px;
  height: 24px;
  position: relative;
  bottom: 2px;
`;

const HelpIcon = styled(Help)`
  width: 24px;
  color: ${theme.palette.primary.hue};
  cursor: pointer;
`;
  
const InfoIcon = styled(Info)`
  width: 20px;
  margin-bottom: 4px;
`;

const SearchIcon = styled(Search)`
  width: 32px;
  color: ${theme.palette.primary.hue};
`;

const NotFoundIcon = styled(PriorityHigh)`
  width: 32px;
  height: 32px;
`;

// New icons
const LogoutIcon = styled(Logout)`
  height: 20px;
  color: lightgrey;
  transition: color 0.2s linear;
  &:hover {
    color: ${theme.palette.primary.hue};
  }
`;

const ContentCopyIcon = styled(ContentCopy)`
  width: 18px;
  margin-bottom: 2px;
`;

const ContentCopyTwoToneIcon = styled(ContentCopyTwoTone)`
  width: 18px;
  margin-bottom: 2px;
  color: ${theme.palette.primary.hue};
`;

const DeleteIcon = styled(Delete)`
  width: 20px;
  color: ${theme.palette.error.hue};
  margin-bottom: 2px;
`;

const MailIcon = styled(Mail)`
  width: 20px;
  margin-bottom: 2px;
`;

const PublicIcon = styled(Public)`
  width: 20px;
  margin-bottom: 2px;
`;

const AddCircleIcon = styled(AddCircle)`
  width: 22px;
  margin-bottom: 3px;
  // color: ${theme.palette.success.hue} !important;
`;

const BrushIcon = styled(Brush)`
  height: 22px;
  margin-bottom: 4px;
  color: ${theme.palette.success.hue} !important;
`;

const HistoryIcon = styled(History)`
  width: 24px;
  height: 24px;
  color: ${theme.palette.success.hue};
  transition: color 0.2s ease-in-out;
`;

const RefreshIcon = styled(Refresh)`
  width: 24px;
  height: 24px;
  margin-left: 3px;
  color: ${theme.palette.success.hue};
  transition: color 0.2s ease-in-out;
`;

const CheckCircleIcon = styled(CheckCircle)`
  width: 22px;
  height: 22px;
  margin: 0 0 2px 6px;
  color: ${theme.palette.primary.hue};
`;

const EditIcon = styled(Edit)`
  width: 20px;
  margin-bottom: 3px;
  margin-left: 3px;
`;

const DoneAllIcon = styled(DoneAll)`
  width: 20px;
  margin-bottom: 2px;
`;

const OutboundIcon = styled(Outbound)`
  width: 20px;
  margin-bottom: 2px;
`;

const MergeIcon = styled(Merge)`
  width: 20px;
  margin-bottom: 2px;
`;

const LocalShippingIcon = styled(LocalShipping)`
  color: ${theme.palette.primary.hue};
  width: 24px;
`;

const ReportIcon = styled(Report)`
  width: 20px;
  margin-bottom: 2px;
`;

const InfoTwoToneIcon = styled(InfoTwoTone)`
  width: 20px;
  margin-bottom: 2px;
`;

const ShoppingCartIcon = styled(ShoppingCart)`
  width: 24px;
  height: 24px;
  margin-left: 3px;
`;

export const SuccessIcon = styled(CheckCircle)`
    color: ${(props: { color?: string }) => props.color || theme.palette.neutral.white};
    width: 20px;
    margin-right: 8px;
`;

export const CancelIcon = styled(MaterialCancel)`
    color: ${(props: { color?: string }) => props.color || theme.palette.neutral.white};
    width: 20px;
    margin-right: 8px;
`;    


export { 
  AddCircleIcon as AddCircle,
  BrushIcon as Brush,
  CancelIcon as Cancel,
  CheckCircleIcon as CheckCircle,
  CheckCircleIcon as Success, // alias for CheckCircle
  ChevronLeftIcon as ChevronLeft,
  ContentCopyIcon as ContentCopy,
  ContentCopyTwoToneIcon as ContentCopyTwoTone,
  DeleteIcon as Delete,
  DoneAllIcon as DoneAll,
  EditIcon as Edit,
  HelpIcon as Help,
  HistoryIcon as History,
  InfoIcon as Info,
  InfoTwoToneIcon as InfoTwoTone,
  LocalShippingIcon as LocalShipping,
  LogoutIcon as Logout,
  MailIcon as Mail,
  MergeIcon as Merge,
  NotFoundIcon as NotFound,
  OutboundIcon as Outbound,
  PublicIcon as Public,
  RefreshIcon as Refresh,
  ReportIcon as Report,
  SearchIcon as Search,
  ShoppingCartIcon as ShoppingCart,
};